var map = {
	"./PB-BRB.png": "6023",
	"./back-soon.png": "3729",
	"./buddies-coin-icon.png": "5d0e",
	"./comp-matcup.png": "19e8",
	"./equipment-marketplace.png": "1535",
	"./exhb-matcup.png": "f800",
	"./ico-live-now-sm.png": "5a29",
	"./ico-live-now.png": "1d2b",
	"./my-equipment.png": "9e4e",
	"./my-players.png": "e8be",
	"./my-team.png": "4357",
	"./pbxp-icon.png": "13c8",
	"./player-marketplace.png": "21f7",
	"./prct-matcup.png": "dbfc",
	"./pro-shop.png": "e960",
	"./puck-buddies-bg.png": "af83"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";